import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Check } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const SelectionButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'visible'
})(({ theme, selected, visible }) => ({
  position: 'absolute',
  top: -13, // Half of height to center on corner
  left: -13, // Half of width to center on corner
  width: 26, // 20% smaller than 32px
  height: 26, // 20% smaller than 32px
  backgroundColor: theme.palette.primary.main, // Always solid blue
  color: 'white',
  border: 'none', // Remove white border to make it solid
  borderRadius: '50%', // Ensure perfect circle
  boxShadow: theme.shadows[2],
  opacity: visible ? 1 : 0,
  transform: visible ? 'scale(1)' : 'scale(0.8)',
  transition: theme.transitions.create(['opacity', 'transform'], {
    duration: theme.transitions.duration.short,
    easing: theme.transitions.easing.easeInOut,
  }),
  zIndex: 1000, // Higher z-index to ensure visibility above card
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    transform: visible ? 'scale(1.1)' : 'scale(0.9)',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1rem', // Slightly smaller to fit the smaller circle
  },
}));

const ListSelectionIndicator = ({ 
  selected = false, 
  visible = false, 
  onToggleSelection 
}) => {
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onToggleSelection?.();
  };

  return (
    <SelectionButton
      selected={selected}
      visible={visible || selected}
      onClick={handleClick}
      size="small"
    >
      <Check />
    </SelectionButton>
  );
};

export default ListSelectionIndicator;